import styles from './ProductCardSimple.module.scss'
import React from 'react'
import Button from '@/components/buttons/Button/Button'
import CartIcon from '@/assets/svg/cart.svg'
import BannerIcon from '@/assets/svg/banner.svg'
import Image from 'next/image'
import { useTranslation } from 'next-i18next'
import usePrice from '@/utils/hooks/usePrice'
import { ArticleModel } from '@/types/api'
import Link from 'next/link'
import { useRouter } from 'next/router'
import useLocalizedLink from '@/utils/hooks/useLocalizedLink'

type Props = {
  headerText: string,
  item: ArticleModel,
  kType?: number,
  onClick: (item: ArticleModel) => void
  buttonLabel: string
}

const ProductCardSimple = ({
  item,
  kType,
  onClick,
  buttonLabel,
  headerText
}: Props) => {
  const { t } = useTranslation()
  const { price } = usePrice()
  const router = useRouter()
  const getLocalizedLink = useLocalizedLink()

  const onClickImage = () => {
    router.push(productLink)
  }

  let productLink = getLocalizedLink(item.productLink)

  if (kType)
    productLink += `?ktype=${kType}`

  return (
    <article className={styles.component}>
      <div className={styles.main}>
        <div className={styles.title}>
          <h2>{headerText}</h2>
          <h1>{item.brandName}</h1>
          <p>{item.articleText}</p>
        </div>
        {item.isNew && (
          <div className={styles.banner}>
            <BannerIcon />
            <div>{t('search.news')}</div>
          </div>
        )}
        <div className={styles.image}>
          {item.imageId && (
            <Image
              src={`${process.env.NEXT_PUBLIC_API}/images/${item.imageId}`}
              alt={item.brandName}
              width={160}
              height={160}
              style={{ objectFit: 'contain' }}
              loading="lazy"
              onClick={onClickImage}
            />
          )}
        </div>
        <div className={styles.buyInfo}>
          <div className={styles.price}>
            <div className={styles.currentPrice}>{price(item.price, true)}</div>
            {item.regularPrice && (
              <div className={styles.regularPrice}>
                {t('shop:regularPrice')} {price(item.regularPrice, true)}
              </div>
            )}
          </div>
          <div className={styles.buttons}>
            <Link href={productLink}>
              <Button
                darkGradient={true}
                rounded={true}
                label={t('search.info')}
                arrow={true}
              />
            </Link>
            <Button
              rounded={true}
              label={buttonLabel || t('select')}
              onClick={() => onClick(item)}
            />
          </div>
        </div>
      </div>
    </article >
  )
}

export default ProductCardSimple